import React, { useState , Fragment, useEffect} from "react";
import Loading from "../assetLibComponents/Loading";
import { useDispatch, useSelector } from "react-redux";
import { StarFill, TrashFill } from "react-bootstrap-icons/dist";
import TabCalender from "../TabCalender";
import { fetchUserList, fetchTimezoneList, fetchScheduleListing, createScheduleData, addOverrideData, deleteSchedule, addScheduleListing } from '../../redux/actions/settingActions';
import { Combobox, Dialog, Listbox, Menu, Transition } from '@headlessui/react'
import { CheckIcon, Cog6ToothIcon, ChevronDownIcon, XMarkIcon } from '@heroicons/react/20/solid'
import { Cog8ToothIcon, DocumentDuplicateIcon, PencilSquareIcon, StarIcon, TrashIcon } from "@heroicons/react/24/outline";
import "../chatAiComponents/ChatAii.css";
import { Switch } from '@headlessui/react'
import Toast from "../assetLibComponents/shared/Toast";
import SettingEvents from "./SettingEvents";

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

const timeSlots =  [
    { id:"", self_id: 1, time: "12:00 AM" },
    { id:"", self_id: 2, time: "12:15 AM" },
    { id:"", self_id: 3, time: "12:30 AM" },
    { id:"", self_id: 4, time: "12:45 AM" },
    { id:"", self_id: 5, time: "01:00 AM" },
    { id:"", self_id: 6, time: "01:15 AM" },
    { id:"", self_id: 7, time: "01:30 AM" },
    { id:"", self_id: 8, time: "01:45 AM" },
    { id:"", self_id: 9, time: "02:00 AM" },
    { id:"", self_id: 10, time: "02:15 AM" },
    { id:"", self_id: 11, time: "02:30 AM" },
    { id:"", self_id: 12, time: "02:45 AM" },
    { id:"", self_id: 13, time: "03:00 AM" },
    { id:"", self_id: 14, time: "03:15 AM" },
    { id:"", self_id: 15, time: "03:30 AM" },
    { id:"", self_id: 16, time: "03:45 AM" },
    { id:"", self_id: 17, time: "04:00 AM" },
    { id:"", self_id: 18, time: "04:15 AM" },
    { id:"", self_id: 19, time: "04:30 AM" },
    { id:"", self_id: 20, time: "04:45 AM" },
    { id:"", self_id: 21, time: "05:00 AM" },
    { id:"", self_id: 22, time: "05:15 AM" },
    { id:"", self_id: 23, time: "05:30 AM" },
    { id:"", self_id: 24, time: "05:45 AM" },
    { id:"", self_id: 25, time: "06:00 AM" },
    { id:"", self_id: 26, time: "06:15 AM" },
    { id:"", self_id: 27, time: "06:30 AM" },
    { id:"", self_id: 28, time: "06:45 AM" },
    { id:"", self_id: 29, time: "07:00 AM" },
    { id:"", self_id: 30, time: "07:15 AM" },
    { id:"", self_id: 31, time: "07:30 AM" },
    { id:"", self_id: 32, time: "07:45 AM" },
    { id:"", self_id: 33, time: "08:00 AM" },
    { id:"", self_id: 34, time: "08:15 AM" },
    { id:"", self_id: 35, time: "08:30 AM" },
    { id:"", self_id: 36, time: "08:45 AM" },
    { id:"", self_id: 37, time: "09:00 AM" },
    { id:"", self_id: 38, time: "09:15 AM" },
    { id:"", self_id: 39, time: "09:30 AM" },
    { id:"", self_id: 40, time: "09:45 AM" },
    { id:"", self_id: 41, time: "10:00 AM" },
    { id:"", self_id: 42, time: "10:15 AM" },
    { id:"", self_id: 43, time: "10:30 AM" },
    { id:"", self_id: 44, time: "10:45 AM" },
    { id:"", self_id: 45, time: "11:00 AM" },
    { id:"", self_id: 46, time: "11:15 AM" },
    { id:"", self_id: 47, time: "11:30 AM" },
    { id:"", self_id: 48, time: "11:45 AM" },
    { id:"", self_id: 49, time: "12:00 PM" },
    { id:"", self_id: 50, time: "12:15 PM" },
    { id:"", self_id: 51, time: "12:30 PM" },
    { id:"", self_id: 52, time: "12:45 PM" },
    { id:"", self_id: 53, time: "01:00 PM" },
    { id:"", self_id: 54, time: "01:15 PM" },
    { id:"", self_id: 55, time: "01:30 PM" },
    { id:"", self_id: 56, time: "01:45 PM" },
    { id:"", self_id: 57, time: "02:00 PM" },
    { id:"", self_id: 58, time: "02:15 PM" },
    { id:"", self_id: 59, time: "02:30 PM" },
    { id:"", self_id: 60, time: "02:45 PM" },
    { id:"", self_id: 61, time: "03:00 PM" },
    { id:"", self_id: 62, time: "03:15 PM" },
    { id:"", self_id: 63, time: "03:30 PM" },
    { id:"", self_id: 64, time: "03:45 PM" },
    { id:"", self_id: 65, time: "04:00 PM" },
    { id:"", self_id: 66, time: "04:15 PM" },
    { id:"", self_id: 67, time: "04:30 PM" },
    { id:"", self_id: 68, time: "04:45 PM" },
    { id:"", self_id: 69, time: "05:00 PM" },
    { id:"", self_id: 70, time: "05:15 PM" },
    { id:"", self_id: 71, time: "05:30 PM" },
    { id:"", self_id: 72, time: "05:45 PM" },
    { id:"", self_id: 73, time: "06:00 PM" },
    { id:"", self_id: 74, time: "06:15 PM" },
    { id:"", self_id: 75, time: "06:30 PM" },
    { id:"", self_id: 76, time: "06:45 PM" },
    { id:"", self_id: 77, time: "07:00 PM" },
    { id:"", self_id: 78, time: "07:15 PM" },
    { id:"", self_id: 79, time: "07:30 PM" },
    { id:"", self_id: 80, time: "07:45 PM" },
    { id:"", self_id: 81, time: "08:00 PM" },
    { id:"", self_id: 82, time: "08:15 PM" },
    { id:"", self_id: 83, time: "08:30 PM" },
    { id:"", self_id: 84, time: "08:45 PM" },
    { id:"", self_id: 85, time: "09:00 PM" },
    { id:"", self_id: 86, time: "09:15 PM" },
    { id:"", self_id: 87, time: "09:30 PM" },
    { id:"", self_id: 88, time: "09:45 PM" },
    { id:"", self_id: 89, time: "10:00 PM" },
    { id:"", self_id: 90, time: "10:15 PM" },
    { id:"", self_id: 91, time: "10:30 PM" },
    { id:"", self_id: 92, time: "10:45 PM" },
    { id:"", self_id: 93, time: "11:00 PM" },
    { id:"", self_id: 94, time: "11:15 PM" },
    { id:"", self_id: 95, time: "11:30 PM" },
    { id:"", self_id: 96, time: "11:45 PM" },
]
const dropdown_day = [
    {
        title: "Sunday",
        check: false,
        disable: false,
    }, {
        title: "Monday",
        check: false,
        disable: false,
    }, {
        title: "Tuesday",
        check: false,
        disable: false,
    }, {
        title: "Wednesday",
        check: false,
        disable: false,
    }, {
        title: "Thursday",
        check: false,
        disable: false,
    }, {
        title: "Friday",
        check: false,
        disable: false,
    }, {
        title: "Saturday",
        check: false,
        disable: false,
    }
];

const publishing_options = [
  { title: 'Edit Name', current: true, icon: PencilSquareIcon },
  { title: 'Set as default', current: false, icon: StarIcon },
  { title: 'Delete', current: false, icon: TrashIcon },
]

const publishing_options2 = [
  { title: 'Edit Name', current: true, icon: PencilSquareIcon }
]

const publishing_event_options = [
  { title: 'Edit', current: true, icon: PencilSquareIcon },
  { title: 'Set as default', current: false, icon: StarIcon },
  { title: 'Setting', current: false, icon: Cog8ToothIcon },
  { title: 'Delete', current: false, icon: TrashIcon },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const SettingCalender = (props) => {
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.chatAi.loading);
    const [tabName, setTabName] = useState("Schedules");
    const [dropdownDay , setDropdownDay] = useState(null);
    const tabs = [
        { name: "Connect", href: "/Setting/connect", current: false },
        { name: "Schedules", href: "/Setting/calender", current: true },
        { name: "Events", href: "/Setting/events", current: false },
    ];
    
    ///////////////////////////////////////////////////////////////
    const authToken = props.authToken;
    const timeZone = useSelector((state) => state.setting.fetchTimeList?.user_timezone);
    const schedule_listing = useSelector((state) => state.setting.fetchScheduleList);
    const [selectedGear, setSelectedGear] = useState(publishing_options[0]);
    const [query, setQuery] = useState('')
    const [schedulePosition, setSchedulePosition] = useState(0);
    // const [eventPosition, setEventPosition] = useState(0);
    const [publishingOptions, setPublishingOptions] = useState([]);
    const [timeSlotData, setTimeSlotData] = useState(null);
    const [activeScheduleData, setActiveScheduleData] = useState(null);
    const [calenderDate, setCalenderDate] = useState("");
    const [calenderFormatDate, setCalenderFormatDate] = useState("");
    const [overlappingError, setOverlappingError] = useState("");
    const [mode, setMode] = useState("");
    const [scheduleName, setScheduleName] = useState("");
    const [popupTimeSlotData, setPopupTimeSlotData] = useState(null);
    const [specificHoursList, setSpecificHoursList] = useState([]);
    const [controlApiCall, setControlApiCall] = useState(false);
    // const [activeEventData, setActiveEventData] = useState(null);
    const [openCalender, setOpenCalender] = useState(false)
    const [openAddPopup, setOpenAddPopup] = useState(false)

    
    const filteredSlots =
    query === ''
      ? timeSlots
      : timeSlots.filter((timeValue) => {
          return timeValue.time.toLowerCase().includes(query.toLowerCase())
      })
    
    useEffect(() => {
        dispatch(fetchUserList(props.authToken, ""));
        // dispatch(fetchTimezoneList(props.authToken, ""));
        dispatch(fetchScheduleListing(props.authToken));
        if (schedule_listing?.length > 0) {
            setActiveScheduleData(schedule_listing[schedulePosition]);
            setTimeSlotData(schedule_listing[schedulePosition]?.weekly_data);
            setSpecificHoursList(schedule_listing[schedulePosition]?.override_data);
        }
        setDropdownDay(dropdown_day);
        setPopupTimeSlotData([
            {
                initialTime: { id:"", self_id: 37, time: "09:00 AM" },
                finalTime: { id:"", self_id: 73, time: "06:00 PM" }
            }
        ]);
        let date = new Date().toDateString()
        setCalenderDate(date.slice(4, 15));
    }, []);
    
    useEffect(() => {
        if (schedule_listing?.length > 0) {
            setActiveScheduleData(schedule_listing[schedulePosition]);
            setTimeSlotData(schedule_listing[schedulePosition]?.weekly_data);
            setSpecificHoursList(schedule_listing[schedulePosition]?.override_data);
        } else {
            if (schedule_listing?.length === 0 && controlApiCall === false) {
                setControlApiCall(true);
            }
        }
    }, [schedule_listing]);
    
    useEffect(() => {
        if (activeScheduleData?.default !== "1") {
            setPublishingOptions(publishing_options);
        } else {
            setPublishingOptions(publishing_options2);
        }
    }, [activeScheduleData])
    
    useEffect(() => {
        if (controlApiCall === true) {
            dispatch(createScheduleData(authToken, "Working Hours", "1", ""))
        }
    }, [controlApiCall])
  
    const handleSettingFunction = (e) => {
        setSelectedGear(e.title);
        if (e.title === "Edit Name") {
            setScheduleName(activeScheduleData?.schedule_name);
            setOpenAddPopup(true);
            setMode("edit");
        } else if (e.title === "Delete") {
            dispatch(deleteSchedule(authToken, activeScheduleData.schedule_id));
            setSchedulePosition(schedulePosition-1);
        } else if (e.title === "Set as default") {
            dispatch(createScheduleData(authToken, activeScheduleData?.schedule_name, "1", timeZone, activeScheduleData?.schedule_id ))
            setSchedulePosition(0);
        } else {
            return
        }
    }
    
    const handleCreateSchedule = () => {
        if (mode === "new") {
            dispatch(createScheduleData(authToken, scheduleName, "0", ""));
            setSchedulePosition(schedule_listing?.length);
        } else {
            dispatch(createScheduleData(authToken, scheduleName, activeScheduleData?.default, timeZone, activeScheduleData?.schedule_id ))
        }
        setOpenAddPopup(false);
    }
    
    const addIntervalAndCheckOverlapPopupTemp = async (initial, final, num) => {
        let slot_array = [...popupTimeSlotData];
        let existingInterval = [];
        slot_array?.map((inner_item, i_ind) => {
            if (initial.self_id > final.self_id) {
                setOverlappingError(`Mismatch interval found for ${initial.time} - ${final.time}`);
            }
            if (num !== i_ind) {
                existingInterval = {
                    initial: inner_item.initialTime,
                    final: inner_item.finalTime
                };
                if (initial.self_id > final.self_id) {
                    setOverlappingError(`Mismatch interval found for ${initial.time} - ${final.time}`);
                } else if ((initial.self_id > existingInterval.initial.self_id && initial.self_id < existingInterval.final.self_id) || (final.self_id > existingInterval.initial.self_id && final.self_id < existingInterval.final.self_id)) {
                    setOverlappingError(`Overlapping interval found for ${initial.time} - ${final.time}`);
                } else if ((initial.self_id < existingInterval.initial.self_id && initial.self_id < existingInterval.final.self_id) || (final.self_id > existingInterval.initial.self_id && final.self_id < existingInterval.final.self_id)) {
                    setOverlappingError(`Overlapping interval found for ${initial.time} - ${final.time}`);
                } else {
                    setOverlappingError("");
                }
            }
            return inner_item;
        })
        // await setTimeSlotData(slot_array);
    }
    
    const addIntervalAndCheckOverlapTemp = async (initial, final, p_num, num) => {
        let slot_array = [...timeSlotData];
        await slot_array?.map((item, index) => {
            if (index === p_num) {
                let existingInterval = [];
                let selectedSlot = item?.selected_slot;

                if (selectedSlot) {
                    for (let i_ind = 0; i_ind < selectedSlot.length; i_ind++) {
                        const inner_item = selectedSlot[i_ind];
                        if (initial.self_id > final.self_id) {
                            item.overlapping_error = `Error: Mismatch interval found for ${initial.time} - ${final.time}`;
                        } else {
                            item.overlapping_error = "";
                        }

                        if (num !== i_ind) {
                            existingInterval = {
                                initial: inner_item.initialTime,
                                final: inner_item.finalTime
                            };

                            if (initial.self_id > final.self_id) {
                                item.overlapping_error = `Error: Mismatch interval found for ${initial.time} - ${final.time}`;
                                break;
                            } else if (
                                (initial.self_id > existingInterval.initial.self_id && initial.self_id < existingInterval.final.self_id) ||
                                (final.self_id > existingInterval.initial.self_id && final.self_id < existingInterval.final.self_id)
                            ) {
                                item.overlapping_error = `Error: Overlapping interval found for ${initial.time} - ${final.time}`;
                                break;
                            } else if (
                                (initial.self_id < existingInterval.initial.self_id && initial.self_id < existingInterval.final.self_id) ||
                                (final.self_id > existingInterval.initial.self_id && final.self_id < existingInterval.final.self_id)
                            ) {
                                item.overlapping_error = `Error: Overlapping interval found for ${initial.time} - ${final.time}`;
                                break;
                            } else {
                                item.overlapping_error = "";
                            }
                        }
                    }
                }
            }
            return item;
        })
        // await setTimeSlotData(slot_array);
    }
    
    const handlePopupSlotChange = async (obj, num, type) => {
        let slot_array = [...popupTimeSlotData];
        slot_array?.map((inner_item, i_ind) => {
            if (i_ind === num) {
                if (type === "initial") {
                    inner_item.initialTime = obj;
                } else {
                    inner_item.finalTime = obj;
                }
                addIntervalAndCheckOverlapPopupTemp(inner_item?.initialTime, inner_item?.finalTime, num);
            }
            return inner_item;
        })
        await setQuery("");
        await setPopupTimeSlotData(slot_array);
    }    
    
    const handleslotChange = async (obj, num, p_num, type) => {
        let slot_array = [...timeSlotData];
        await slot_array?.map((item, index) => {
            if (index === p_num) {
                item?.selected_slot?.map((inner_item, i_ind) => {
                    if (i_ind === num) {
                        if (type === "initial") {
                            inner_item.initialTime = obj;
                            inner_item.finalTime = {id:"",time:inner_item.finalTime.time,self_id:obj.self_id};
                        } else {
                            inner_item.initialTime = {id:"",time:inner_item.initialTime.time,self_id:obj.self_id};;
                            inner_item.finalTime = obj;
                        }
                        addIntervalAndCheckOverlapTemp(inner_item?.initialTime, inner_item?.finalTime, p_num, num);
                    }
                    // if (i_ind !== 0) {
                    //     addIntervalAndCheckOverlap(inner_item?.initialTime?.time, inner_item?.finalTime?.time, p_num, num);
                    // }
                    return inner_item;
                })
            }
            return item;
        })
        await setQuery("");
        await setTimeSlotData(slot_array);
    }    
    
    const handleCheckboxChange = async (checkValue, num) => {
        let slot_array = [...timeSlotData];
        let slot_obj = {
            initialTime: { id:"", self_id: 37, time: "09:00 AM" },
            finalTime: { id:"", self_id: 73, time: "06:00 PM" }
        }
        await slot_array?.map((item, index) => {
            if (index === num) {
                item.availability = checkValue?.target?.checked;
                if (checkValue?.target?.checked === true && item.selected_slot?.length === 0) {
                    item?.selected_slot?.push(slot_obj)
                }
                item.overlapping_error = "";
            }
            return item;
        })
        await setQuery("");
        await setTimeSlotData(slot_array);
    }
    
    const handleslotAdd = async (num) => {
        let slot_array = [...timeSlotData];
        await slot_array?.map((item, index) => {
            if (index === num) {
                if (item?.selected_slot?.length < 3) {
                    let slot_obj;
                    if (item?.selected_slot?.length !== 0 && item?.overlapping_error && item?.overlapping_error !== "") {
                        Toast("Clear the overlapping before adding next","E");
                    } else {
                        if (item?.selected_slot?.length === 0) {
                            slot_obj = {
                                initialTime: { id:"", self_id: 37, time: "09:00 AM" },
                                finalTime: { id:"", self_id: 73, time: "06:00 PM" }
                            } 
                        } else {
                            let i_data, f_data;
                            let insisde_data = item?.selected_slot[item?.selected_slot?.length - 1];
                            i_data = timeSlots.filter((item) => item.self_id === insisde_data?.finalTime?.self_id + 4);
                            f_data = timeSlots.filter((item) => item.self_id === insisde_data?.finalTime?.self_id + 8);
                            slot_obj = {
                                initialTime: i_data[0],
                                finalTime: f_data[0],
                            } 
                        }
                        item.overlapping_error = "";
                        item?.selected_slot?.push(slot_obj);
                        item.availability = true;
                    }

                }
            }
            return item;
        })
        await setQuery("");
        await setTimeSlotData(slot_array);
    }
      
    const handleDeleteSlot = async (num, p_num) => {
        let slot_array = [...timeSlotData];
        await slot_array?.map((item, index) => {
            if (index === p_num) {
                item.selected_slot = item?.selected_slot.filter((inner, i_index) => i_index !== num);
                if (item.selected_slot?.length === 0) {
                    item.availability = false;
                }
            }
            return item;
        })
        await setQuery("");
        await setTimeSlotData(slot_array);
    }
    
    const handleCopyData = (p_num, n_num) => {
        let drop_data = [...dropdownDay];
        drop_data.map((item, index) => {
            if (index === n_num) {
                item.check = !item.check
            }
            if (index === p_num) {
                item.disable = true;
            } else {
                item.disable = false;
            }
            return item;
        })
        setDropdownDay(drop_data);
    }
    
    const handleResetCopyData = (p_num, n_num) => {
        let drop_data = [...dropdownDay];
        drop_data.map((item) => {
            item.check = false;
            item.disable = true;
            item.disable = false;
            return item;
        })
        setDropdownDay(drop_data);
    }
    
    const applyCopyData = async (slotData) => {
        let slot_array = [...timeSlotData];
        await slot_array?.map((item, index) => {
            dropdownDay.map((d_data, d_ind) => {
                if (index === d_ind && d_data.check === true) {
                    item.selected_slot = slotData; 
                    if (slotData.length > 0) {
                        item.availability = true;    
                    } else {
                        item.availability = false; 
                    }                
                }
                return d_data;
            })
            return item;
        })
        await setQuery("");
        await setTimeSlotData(slot_array);
        await handleResetCopyData();
    }
    
    const handleSpecificScheduleDisplay = (schedule_data, num) => {
        setSchedulePosition(num);
        setTimeSlotData(schedule_data?.weekly_data);
        setActiveScheduleData(schedule_data)
        setSpecificHoursList(schedule_data?.override_data);
    }
    
    const handlePopupTimeSlot = async () => {
        if (popupTimeSlotData?.length < 3) {
            let slot_array = [...popupTimeSlotData];
            let slot_obj = {};
            if (slot_array?.length === 0) {
                slot_obj = {
                    initialTime: { id:"", self_id: 37, time: "09:00 AM" },
                    finalTime: { id:"", self_id: 73, time: "06:00 PM" }
                } 
            } else {
                let i_data, f_data;
                let inside_data = slot_array[slot_array?.length - 1];
                i_data = timeSlots.filter((item) => item.self_id === inside_data?.finalTime?.self_id + 4);
                f_data = timeSlots.filter((item) => item.self_id === inside_data?.finalTime?.self_id + 8);
                slot_obj = {
                    initialTime: i_data[0],
                    finalTime: f_data[0],
                } 
            }
            slot_array?.push(slot_obj);
            await setQuery("");
            await setPopupTimeSlotData(slot_array);
        }
    }
    
    const handleDeletePopupSlot = async (num) => {
        let slot_array = [...popupTimeSlotData];
        slot_array = await slot_array?.filter((inner, i_index) => i_index !== num)
        await setQuery("");
        await setPopupTimeSlotData(slot_array);
    }
    
    const handleSpecificHoursSubmit = async () => {
        let date = new Date().toDateString()
        setCalenderDate(date.slice(4, 15));
        await dispatch(addOverrideData(authToken, activeScheduleData, calenderFormatDate?.trim(), popupTimeSlotData, false, popupTimeSlotData?.length > 0 ? true : false));
        await handleSubmitScheduleData();
        setPopupTimeSlotData([
            {
                initialTime: { id:"", self_id: 37, time: "09:00 AM" },
                finalTime: { id:"", self_id: 73, time: "06:00 PM" }
            }
        ]);
    }
    
    const handleCalenderDate = async (value, event) => {
        let str = value?.toDateString();
        let date = str?.slice(4, 15);
        setCalenderDate(date);
        let new_date = await handleDateFormatting(date);
        setCalenderFormatDate(new_date);
        
    }   
    
    const handleAddOverrideDate = async () => {
        let date = new Date().toDateString()
        let data = date?.slice(4, 15);
        setCalenderDate(data);
        let new_date = await handleDateFormatting(data);
        setCalenderFormatDate(new_date);
        setPopupTimeSlotData([
            {
                initialTime: { id:"", self_id: 37, time: "09:00 AM" },
                finalTime: { id:"", self_id: 73, time: "06:00 PM" }
            }
        ]);
        setOpenCalender(true);
    }
    
    const deleteSpecificDate = async (date, data_slot) => {
        // let new_date = await handleDateFormatting(date);
        await dispatch(addOverrideData(authToken, activeScheduleData, date, data_slot, true));
        dispatch(fetchScheduleListing(props.authToken));
    }
    
    const handleDateFormat = async (data, data_slot) => {
        let new_date = await handleDateFormatting(data);
        setCalenderFormatDate(new_date);
        setOpenCalender(true);
        setPopupTimeSlotData(data_slot);
    }
    
    const handleDateFormatting = (data) => {
        let month = ["Jan", "Feb", "Mar", "Apr", 'May', "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let month_num = month.indexOf(data.slice(0, 3)) + 1;
        month_num = month_num < 10 ? "0" + month_num : month_num.toString();
        let date = data.slice(6, 12) + "-" + month_num + "-" + data.slice(4, 7);
        return date;
    }
    
    const handleSubmitScheduleData = () => {
        let payload = {};
        payload = {
            schedule_id: activeScheduleData?.schedule_id,
            weekly_data: timeSlotData
        }
        dispatch(addScheduleListing(authToken, payload));
    }
    
    return (
        <>
        {isLoading && <Loading />}
            {/* Tabs */}
            <div className="px-6 sm:px-8 mb-4 lg:px-10">
                <TabCalender tabs={tabs} setTabName={setTabName} tabName={tabName} />  
            </div>
            {/* Tabs Content */}
            <div className="max-sm:h-full h-[78vh] listing">
                <div className="h-[78vh] max-sm:h-[80vh] listing overflow-auto px-6 sm:px-8 lg:px-10">
                    <div className="max-sm:w-[550px]">
                        <div className="mb-4 flex justify-between items-center">
                            <div className="flex items-center">  
                                {schedule_listing?.map((schedule, s_index) => {
                                    return (
                                        <>
                                            {s_index < 2 &&
                                                <span
                                                    className={"mr-[15px] max-sm:w-[150px] flex max-sm:justify-center px-5 max-sm:px-2 py-2 cursor-pointer border-2 border-solid font-semibold rounded-md" + (activeScheduleData?.schedule_id === schedule?.schedule_id ? " border-[var(--brand-primary)] text-[var(--brand-primary)] " : " border-[gray] text-[gray] ")}
                                                    onClick={() => {
                                                        handleSpecificScheduleDisplay(schedule, s_index)
                                                    }}
                                                >
                                                    {schedule?.default === "1" &&
                                                        <StarFill
                                                            className={"h-5 w-5 mr-2 " + (activeScheduleData?.schedule_id === schedule?.schedule_id ? "text-[var(--brand-primary)]" : "text-gray")}
                                                            aria-hidden="true"
                                                        />}
                                                    <span className="max-sm:w-[70%] w-full whitespace-nowrap overflow-hidden text-ellipsis">{schedule.schedule_name}</span>
                                                </span>}
                                        </>
                                    );
                                })} 

                                {schedule_listing?.length > 2 && <Listbox value={activeScheduleData?.schedule_name} onChange={(e) => { handleSpecificScheduleDisplay(e.schedule, e.num); }}>
                                    {({ open }) => (
                                    <>
                                    <div className="relative mt-0">
                                        <Listbox.Button className="bg-transparent hover:text-[var(--brand-primary)] relative cursor-pointer w-full rounded-md py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">
                                        <span className="block truncate">{"+ "+ (schedule_listing?.length - 2)+" more"}</span>
                                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                            <ChevronDownIcon className="h-5 w-5  hover:text-[var(--brand-primary)]" aria-hidden="true" />
                                        </span>
                                        </Listbox.Button>

                                        <Transition
                                        show={open}
                                        as={Fragment}
                                        leave="transition ease-in duration-100"
                                        leaveFrom="opacity-100"
                                        leaveTo="opacity-0"
                                        >
                                        <Listbox.Options className="absolute z-10 mt-1 w-60 max-h-60 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                            {schedule_listing.map((schedule, s_index) => (
                                                <>
                                                    {s_index > 1 && <Listbox.Option
                                                        key={schedule.id}
                                                        className={({ active }) =>
                                                        classNames(
                                                            active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                                            'relative cursor-default select-none py-2 pl-3 pr-9'
                                                        )
                                                        }
                                                        value={
                                                            {
                                                                schedule:schedule,
                                                                num:s_index
                                                            }   
                                                        }
                                                    >
                                                        <>
                                                            <span className={classNames(true ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                            {schedule.schedule_name}
                                                            </span>
                                                            {activeScheduleData?.schedule_id === schedule?.schedule_id && <span
                                                                className='text-[var(--brand-primary)] absolute inset-y-0 right-0 flex items-center pr-4'
                                                            >
                                                                <CheckIcon className="h-4 w-4" aria-hidden="true" />
                                                            </span>}
                                                        </>
                                                    </Listbox.Option>}
                                                </>
                                            ))}
                                        </Listbox.Options>
                                        </Transition>
                                    </div>
                                    </>
                                    )}
                                </Listbox>  }                                  
                            </div>
                            {schedule_listing?.length < 5 && <div className="">
                                <button className="hover:underline hover:underline-offset-8" onClick={() => { setScheduleName(""); setOpenAddPopup(true); setMode("new"); }}>+ New Schedule</button>
                            </div>}  
                        </div>    
                        <div className="bg-white rounded-t-md border border-solid border-[lightgray] border-b-0 px-4 py-3 mt-2">
                            <div className="flex justify-between">
                                <p className="font-bold text-lg flex items-center">{activeScheduleData?.schedule_name} {activeScheduleData?.default === "1" && <StarFill className="h-5 w-5 ml-2 text-[var(--brand-primary)]" aria-hidden="true" />}</p> 
                                <div className="flex items-center">
                                    <button
                                        onClick={()=>{handleSubmitScheduleData()}}
                                        type="button"
                                        className="mr-4 inline-flex bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] items-center gap-x-1.5 rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm"
                                    >
                                    Save Changes
                                    </button>                                    
                                    {/* main setting icon dropwon (Working Hours) */}  
                                    <Listbox value={selectedGear} onChange={(e) => { handleSettingFunction(e) }}>
                                        {({ open }) => (
                                            <>
                                            <div className="relative">
                                                <div className="inline-flex divide-x divide-indigo-700 shadow-sm">
                                                    <Listbox.Button className="inline-flex items-center rounded-md bg-transparent p-1 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] focus:ring-offset-2 focus:ring-offset-gray-50">
                                                        <Cog6ToothIcon className="h-5 w-5 text-[gray]" aria-hidden="true" />
                                                    </Listbox.Button>
                                                </div>
                                                <Transition
                                                show={open}
                                                as={Fragment}
                                                leave="transition ease-in duration-100"
                                                leaveFrom="opacity-100"
                                                leaveTo="opacity-0"
                                                >
                                                <Listbox.Options className="absolute right-0 z-10 mt-2 w-40 origin-top-right divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                    {publishingOptions.map((option) => (
                                                    <Listbox.Option
                                                        key={option.title}
                                                        className={({ active }) =>
                                                        classNames(
                                                            active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                                            'cursor-default select-none p-2 text-sm'
                                                        )
                                                        }
                                                        value={option}
                                                    >
                                                        {({ selectedGear, active }) => (
                                                        <div className="flex flex-col">
                                                            <div className="flex items-center">
                                                                <option.icon
                                                                    className='h-4 w-4 shrink-0 mr-2'
                                                                    aria-hidden="true"
                                                                />
                                                                <p className={selectedGear ? 'font-semibold' : 'font-normal'}>{option.title}</p>
                                                                {selectedGear ? (
                                                                    <span className={active ? 'text-white' : 'text-[var(--brand-primary)]'}>
                                                                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                                    </span>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        )}
                                                    </Listbox.Option>
                                                    ))}
                                                </Listbox.Options>
                                                </Transition>
                                            </div>
                                        </>
                                    )}
                                    </Listbox>
                                    {/* main setting icon dropwon (Working Hours) */}  
                                </div>  
                            </div>
                        </div>
                        <div className="bg-white rounded-b-md flex max-sm:block border border-solid border-[lightgray] px-4 py-0">
                            <div className="w-1/2 max-sm:w-full max-sm:border-none border-r h-full border-solid border-[lightgray]">
                                <p className="font-semibold my-2">Set your weekly hours</p> 
                                <div className="listing">  
                                    {timeSlotData && timeSlotData.map((week_day, w_index) => {
                                        return (
                                            <div className="sm:px-0 py-4 border-b border-solid border-[lightgray]">
                                                {(week_day.availability === true && week_day?.overlapping_error !== "") && <p className="font-semibold text-red-500 my-2">{week_day?.overlapping_error}</p>}
                                                <div className="flex items-center justify-between">
                                                    <div className="listing-check my-auto flex">
                                                        <input
                                                            type="checkbox"
                                                            className="me-2"
                                                            onChange={(e) => handleCheckboxChange(e, w_index)}
                                                            checked={week_day.availability}
                                                        />
                                                    </div>
                                                        <span className="text-gray-900 flex items-center text-sm not-italic font-bold w-[10%] max-sm:w-[50 overflow-hidden text-ellipsis capitalize whitespace-nowrap ml-2.5 max-sm:ml-0">{week_day.day_short_name}</span>
                                                        <div className="text-gray-900 block items-center text-sm not-italic font-medium w-[65%] max-sm:w-[50 overflow-hidden text-ellipsis whitespace-nowrap ml-2.5">
                                                            {week_day.availability === true ? <>
                                                                {week_day.selected_slot.map((slot_one,s_ind)=>{
                                                                return (
                                                                    <div className="flex mb-2" key={"time"+s_ind}>
                                                                        {/* set weekly hours time 1 dropdown */}
                                                                        <Combobox as="div" value={slot_one.initialTime}
                                                                            disabled={(week_day?.selected_slot?.length - 1) - s_ind !== 0}
                                                                            onChange={(e) => {
                                                                                handleslotChange(e, s_ind, w_index, "initial");
                                                                            }}
                                                                        >
                                                                            <div className="relative ">
                                                                                <Combobox.Input
                                                                                className={"w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"+((week_day?.selected_slot?.length - 1) - s_ind === 0 ? " cursor-pointer " : " cursor-no-drop ")}
                                                                                onChange={(event) => setQuery(event.target.value)}
                                                                                displayValue={(timeValue) => timeValue?.time}
                                                                                />
                                                                                <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                                                                <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                                </Combobox.Button>

                                                                                {filteredSlots.length > 0 && (
                                                                                <Combobox.Options className="relative z-10 mt-1 max-h-28 listing w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                                                    {filteredSlots.map((timeValue) => (
                                                                                    <Combobox.Option
                                                                                        key={timeValue.id}
                                                                                        value={timeValue}
                                                                                        className={({ active }) =>
                                                                                            classNames(
                                                                                                'relative cursor-default select-none py-2 pl-3 pr-9',
                                                                                                active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900'
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        {({ active, selected }) => (
                                                                                        <>
                                                                                            <span className={classNames('block truncate', selected && 'font-semibold')}>{timeValue.time}</span>

                                                                                            {selected && (
                                                                                            <span
                                                                                                className={classNames(
                                                                                                'absolute inset-y-0 right-0 flex items-center pr-4',
                                                                                                active ? 'text-white' : 'text-[var(--brand-primary)]'
                                                                                                )}
                                                                                            >
                                                                                                <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                                                            </span>
                                                                                            )}
                                                                                        </>
                                                                                        )}
                                                                                    </Combobox.Option>
                                                                                    ))}
                                                                                </Combobox.Options>
                                                                                )}
                                                                            </div>
                                                                        </Combobox>
                                                                        {/* set weekly hours time 1 dropdown */}
                                                                    
                                                                        {/* set weekly hours time 2 dropdown */}
                                                                        <span className="px-2 pb-2 text-gray-400">_</span>
                                                                        <Combobox as="div" value={slot_one.finalTime}
                                                                            disabled={(week_day?.selected_slot?.length-1) - s_ind !== 0 }
                                                                            onChange={(e) => {
                                                                                handleslotChange(e, s_ind, w_index, "final")
                                                                            }}
                                                                        >
                                                                            <div className="relative">
                                                                                <Combobox.Input
                                                                                className={"w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6" +((week_day?.selected_slot?.length - 1) - s_ind === 0 ? " cursor-pointer " : " cursor-no-drop ")}
                                                                                onChange={(event) => setQuery(event.target.value)}
                                                                                displayValue={(timeValue2) => timeValue2?.time}
                                                                                />
                                                                                <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                                                                <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                                </Combobox.Button>

                                                                                {filteredSlots?.length > 0 && (
                                                                                <Combobox.Options className="relative z-10 mt-1 max-h-28 listing w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                                                    {filteredSlots.map((timeValue2) => (
                                                                                    <Combobox.Option
                                                                                        key={timeValue2.id}
                                                                                        value={timeValue2}
                                                                                        className={({ active }) =>
                                                                                        classNames(
                                                                                            'relative cursor-default select-none py-2 pl-3 pr-9',
                                                                                            active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                                                                            
                                                                                        )
                                                                                        }
                                                                                    >
                                                                                        {({ active, selected }) => (
                                                                                        <>
                                                                                            <span className={classNames('block truncate', selected && 'font-semibold')}>{timeValue2.time}</span>

                                                                                            {selected && (
                                                                                            <span
                                                                                                className={classNames(
                                                                                                'absolute inset-y-0 right-0 flex items-center pr-4',
                                                                                                active ? 'text-white' : 'text-[var(--brand-primary)]'
                                                                                                )}
                                                                                            >
                                                                                                <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                                                            </span>
                                                                                            )}
                                                                                        </>
                                                                                        )}
                                                                                    </Combobox.Option>
                                                                                    ))}
                                                                                </Combobox.Options>
                                                                                )}
                                                                            </div>
                                                                        </Combobox>
                                                                        {/* set weekly hours time 2 dropdown */}
                                                                        <TrashFill className={"h-8 w-8 ml-2 text-gray-500"+((week_day?.selected_slot?.length - 1) - s_ind === 0 ? " cursor-pointer " : " cursor-no-drop ")}
                                                                            onClick={() => {
                                                                                if ((week_day?.selected_slot?.length - 1) - s_ind === 0){
                                                                                    handleDeleteSlot(s_ind, w_index);
                                                                                }
                                                                            }}
                                                                            aria-hidden="true"
                                                                        />
                                                                    </div>
                                                                ); 
                                                                })}
                                                            </> :
                                                            <><p>Unavailable</p></>}
                                                        </div>
                                                        <div className="w-[30%] max-sm:w-[25%] flex justify-end items-center">
                                                            <span className="inline-flex uppercase items-center rounded-md bg-gray-100 cursor-pointer text-lg ml-4 max-sm:ml-1 px-2 py-0 font-medium text-gray-400 ring-1 ring-inset ring-gray-500/10" onClick={()=>{handleslotAdd(w_index)}}>+</span>
                                                            {/* individual week days operation dropdown */}
                                                            <Menu as="div" className="relative inline-block text-left mx-4">
                                                            <div>
                                                                <Menu.Button className="flex items-center rounded-full text-gray-400 focus:drop-shadow-none	focus:shadow-none focus-visible:drop-shadow-none focus-visible:shadow-none hover:text-gray-600 focus:outline-none focus:ring-0 focus:ring-white-500 focus:ring-offset-0 focus:ring-offset-white-100">
                                                                <span className="sr-only">Open options</span>
                                                                <DocumentDuplicateIcon className="h-5 w-5" aria-hidden="true" />
                                                                </Menu.Button>
                                                            </div>

                                                            <Transition
                                                                as={Fragment}
                                                                enter="transition ease-out duration-100"
                                                                enterFrom="transform opacity-0 scale-95"
                                                                enterTo="transform opacity-100 scale-100"
                                                                leave="transition ease-in duration-75"
                                                                leaveFrom="transform opacity-100 scale-100"
                                                                leaveTo="transform opacity-0 scale-95"
                                                            >
                                                                <Menu.Items className={"absolute right-0 z-10 mt-2 w-56 origin-bottom rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none " + (w_index > 2 ? " bottom-[30px]":"")}>
                                                                    <p className="text-xs px-3.5 py-[5px] font-semibold">Copy times to..</p>
                                                                    <div className="py-1">
                                                                        {dropdownDay?.map((data, d_ind) => {
                                                                            return (
                                                                                <div className="relative hover:bg-gray-100 hover:text-gray-900 text-gray-700">
                                                                                    { w_index === d_ind && <span className="absolute bg-[#83828247] z-30 left-0 w-full h-full top-0"></span>}
                                                                                    <div className="flex relative justify-between hover:bg-gray-100 hover:text-gray-900 text-gray-700" onClick={()=>{handleCopyData(w_index, d_ind)}}>
                                                                                        <span
                                                                                            className='block px-4 py-2 font-semibold text-sm cursor-pointer'
                                                                                        >
                                                                                            {data.title}    
                                                                                        </span>
                                                                                        <div className={"my-auto flex " + ( w_index !== d_ind ? "listing-check":"listing-check-disable")}>
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                className="me-2"
                                                                                                disabled={data.disable}
                                                                                                onChange={() => {
                                                                                                    console.log("working")
                                                                                                }}
                                                                                                checked={w_index === d_ind || data.check}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                    <div className="flex justify-center mb-4 mt-2">
                                                                        <Menu.Item>
                                                                            <button
                                                                                type="button"
                                                                                onClick={()=>{applyCopyData(week_day.selected_slot)}}
                                                                                className="rounded bg-[var(--brand-primary)] px-20 py-1 text-sm font-semibold text-white shadow-sm hover:bg-[#50909c] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                                            >
                                                                                Apply
                                                                            </button>
                                                                        </Menu.Item>
                                                                    </div>
                                                                </Menu.Items>
                                                            </Transition>
                                                            </Menu>
                                                            {/* individual week days operation dropdown */}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="w-1/2 max-sm:w-full h-full pl-4">
                                <p className="font-semibold my-2">Date-specific hours</p>
                                <p className="font-normal my-2 text-[11px]">Override your availability for specific dates when your hours differ from your regular weekly hours.</p>
                                <button
                                    type="button"
                                    className="rounded-md bg-[var(--brand-primary)] px-4 py-1.5 text-sm font-normal text-white shadow-sm hover:bg-[#4aa5b6] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                                    onClick={() => { handleAddOverrideDate() }}
                                >
                                    + Add date specific hours
                                </button>
                                <div className="mt-6">
                                {specificHoursList?.length > 0 && specificHoursList.map(( listItem, l_index) => {
                                    return (
                                        <div className="flex hover:bg-slate-300 p-2 hover:rounded-md cursor-pointer justify-between pr-4">
                                            <span onClick={() => { handleDateFormat(listItem?.date, listItem?.slot_data); }}>{listItem?.date}</span>
                                            <div className="grid">
                                                {listItem?.slot_data?.length > 0 ? <>
                                                    {listItem?.slot_data?.map((slot, s_ind)=>{
                                                        return (
                                                            <span>{slot?.initialTime.time} - {slot?.finalTime.time}</span>
                                                        );
                                                    })}
                                                </>
                                                :
                                                <>
                                                    <span>Unavailable</span>
                                                </>}
                                            </div>
                                            <span className="cursor-pointer text-lg" onClick={()=>{deleteSpecificDate(listItem?.date, listItem?.slot_data)}}><XMarkIcon className="h-4 w-4" /></span>
                                        </div>
                                    );
                                })}
                                </div>  
                            </div>
                        </div>
                    </div>  
                </div>
            </div>
            
            <Transition.Root show={openCalender} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpenCalender}>
                    <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                        <Dialog.Panel className="relative min-w-[700px] max-sm:min-w-[auto] transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                            <p className="font-semibold border-b pr-4 pb-4 h-full border-solid border-[lightgray] max-sm:text-[12px]">Select the date(s) you want to assign specific hours</p>
                            <div className="flex max-sm:block">
                                <div className="w-1/2 max-sm:w-full pr-4 max-sm:pr-0">
                                    <div>
                                        <Calendar minDate={new Date()} onChange={handleCalenderDate} value={calenderFormatDate} />
                                    </div>
                                </div>
                                <div className="w-1/2 max-sm:mt-4 max-sm:border-t max-sm:border-solid max-sm:border-[lightgray] max-sm:w-full max-sm:pl-0 pl-4">
                                <p className="font-normal flex justify-between items-center mt-4">What hours are you available? <span className="inline-flex uppercase items-center rounded-md bg-gray-100 cursor-pointer text-lg ml-2 max-sm:ml-1 px-3 py-0 font-medium text-gray-400 ring-1 ring-inset ring-gray-500/10" onClick={handlePopupTimeSlot}>+</span></p>
                                {(overlappingError !== "") && <p className="text-[12px] font-semibold text-red-500 my-2">{overlappingError}</p>}                                            
                                <div className="flex justify-between items-start px-0 pt-4 sm:px-0 py-2 h-[42vh] max-sm:h-[25vh] overflow-y-auto">
                                    <div className="text-gray-900 text-sm not-italic font-medium w-[100%] overflow-hidden text-ellipsis whitespace-nowrap">
                                        {popupTimeSlotData?.length > 0 ? <>
                                            {popupTimeSlotData?.length > 0 && popupTimeSlotData?.map((slot_one, s_ind) => {
                                                return (
                                                    <div className="flex mb-2" key={"time"+s_ind}>
                                                        {/* set weekly hours time 1 dropdown */}
                                                        <Combobox as="div" value={slot_one.initialTime}
                                                            disabled={(popupTimeSlotData?.length - 1) - s_ind !== 0}
                                                            onChange={(e) => {
                                                                handlePopupSlotChange(e, s_ind, "initial");
                                                            }}
                                                        >
                                                            <div className="relative">
                                                                <Combobox.Input
                                                                className="w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                                                onChange={(event) => setQuery(event.target.value)}
                                                                displayValue={(timeValue) => timeValue?.time}
                                                                />
                                                                <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                                                <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                </Combobox.Button>

                                                                {filteredSlots?.length > 0 && (
                                                                <Combobox.Options className="relative z-10 mt-1 max-h-28 listing w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                                    {filteredSlots.map((timeValue) => (
                                                                    <Combobox.Option
                                                                        key={timeValue.id}
                                                                        value={timeValue}
                                                                        className={({ active }) =>
                                                                            classNames(
                                                                                'relative cursor-default select-none py-2 pl-3 pr-9',
                                                                                active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900'
                                                                            )
                                                                        }
                                                                    >
                                                                        {({ active, selected }) => (
                                                                        <>
                                                                            <span className={classNames('block truncate', selected && 'font-semibold')}>{timeValue.time}</span>

                                                                            {selected && (
                                                                            <span
                                                                                className={classNames(
                                                                                'absolute inset-y-0 right-0 flex items-center pr-4',
                                                                                active ? 'text-white' : 'text-[var(--brand-primary)]'
                                                                                )}
                                                                            >
                                                                                <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                                            </span>
                                                                            )}
                                                                        </>
                                                                        )}
                                                                    </Combobox.Option>
                                                                    ))}
                                                                </Combobox.Options>
                                                                )}
                                                            </div>
                                                        </Combobox>
                                                        {/* set weekly hours time 1 dropdown */}
                                                    
                                                        {/* set weekly hours time 2 dropdown */}
                                                        <span className="px-2 pb-2 text-gray-400">_</span>
                                                        <Combobox as="div" value={slot_one.finalTime}
                                                            disabled={(popupTimeSlotData?.length - 1) - s_ind !== 0}
                                                            onChange={(e) => {
                                                                handlePopupSlotChange(e, s_ind, "final");
                                                            }}
                                                        >
                                                            <div className="relative">
                                                            <Combobox.Input
                                                                className="w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                                                onChange={(event) => setQuery(event.target.value)}
                                                                displayValue={(timeValue2) => timeValue2?.time}
                                                            />
                                                                <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                                                <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                </Combobox.Button>

                                                                {filteredSlots?.length > 0 && (
                                                                <Combobox.Options className="relative z-10 mt-1 max-h-28 listing w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                                    {filteredSlots.map((timeValue2) => (
                                                                    <Combobox.Option
                                                                        key={timeValue2.id}
                                                                        value={timeValue2}
                                                                        className={({ active }) =>
                                                                        classNames(
                                                                            'relative cursor-default select-none py-2 pl-3 pr-9',
                                                                            active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900'
                                                                        )
                                                                        }
                                                                    >
                                                                        {({ active, selected }) => (
                                                                        <>
                                                                            <span className={classNames('block truncate', selected && 'font-semibold')}>{timeValue2.time}</span>

                                                                            {selected && (
                                                                            <span
                                                                                className={classNames(
                                                                                'absolute inset-y-0 right-0 flex items-center pr-4',
                                                                                active ? 'text-white' : 'text-[var(--brand-primary)]'
                                                                                )}
                                                                            >
                                                                                <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                                            </span>
                                                                            )}
                                                                        </>
                                                                        )}
                                                                    </Combobox.Option>
                                                                    ))}
                                                                </Combobox.Options>
                                                                )}
                                                            </div>
                                                        </Combobox>
                                                        {/* set weekly hours time 2 dropdown */}
                                                        <TrashFill className="h-8 w-8 cursor-pointer ml-2 text-gray-500" onClick={() => { handleDeletePopupSlot(s_ind); }} aria-hidden="true" />
                                                    </div>
                                                ); 
                                            })}
                                        </>
                                        :
                                        <>
                                           <p className="w-max border px-[15px] py-[5px] rounded-[5px] border-solid border-[gray] bg-[lightgray]">Unavailable</p>         
                                        </>}                                                 
                                    </div>
                                </div>
                                <div className="text-right">
                                    <button
                                        type="button"
                                        className="mt-0 ml-4 rounded-md bg-[#ffffff] border border-solid border-[var(--brand-primary)] px-3 py-1 text-sm font-semibold text-[var(--brand-primary)] shadow focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                                        onClick={() => {
                                            setOpenCalender(false);
                                        }}
                                    >
                                        Cancel
                                    </button>              
                                    <button
                                        type="button"
                                        className="mt-0 ml-2 rounded-md bg-[var(--brand-primary)] px-3 py-1 text-sm font-semibold text-white shadow hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                                        onClick={() => {
                                            handleSpecificHoursSubmit();    
                                            setOpenCalender(false);
                                        }}
                                    >
                                        Apply
                                    </button>
                                </div>            
                                </div>
                            </div>
                        </Dialog.Panel>
                        </Transition.Child>
                    </div>
                    </div>
                </Dialog>
            </Transition.Root> 
            
            <Transition.Root show={openAddPopup} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpenAddPopup}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                        <Dialog.Panel className="relative max-sm:w-full transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                            <div>
                                <div className="text-left">
                                    <Dialog.Title as="h3" className="text-lg font-semibold leading-6 text-gray-900">
                                    {mode === "new" ? "New":"Edit"} schedule
                                    </Dialog.Title>
                                    <div>
                                        <label htmlFor="name" className="block text-xs mt-4 font-medium leading-6 text-gray-900">
                                            Schedule name
                                        </label>
                                        <div className="mt-2">
                                            <input
                                            type="name"
                                            name="name"
                                            id="name"
                                            value={scheduleName}            
                                            onChange={(e) => { setScheduleName(e.target.value); }}            
                                            className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 focus-visible:outline-none ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                            placeholder="Working Hours, Exclusive Hours, etc..."
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex text-right mt-4">
                                <button
                                    type="button"
                                    className="mt-0 w-1/2 rounded-md bg-[#ffffff] border border-solid border-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-[var(--brand-primary)] shadow focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                                    onClick={() => {
                                        setOpenAddPopup(false);
                                    }}
                                >
                                    Cancel
                                </button>              
                                <button
                                    type="button"
                                    className="mt-0 ml-2 w-1/2 rounded-md bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] px-3 py-2 text-sm font-semibold text-white shadow focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                                    onClick={() => {
                                        handleCreateSchedule();    
                                    }}
                                >
                                    {mode === "new" ? "Create":"Update"}
                                </button>
                            </div>     
                        </Dialog.Panel>
                        </Transition.Child>
                    </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );
};

export default SettingCalender;
